import React, { useEffect, useState } from 'react';
import { Delete, Check, Minus } from 'lucide-react';
import { Button } from './ui/Button';
interface FillInBlankProps {
  onAnswer: (answer: string) => void;
  disabled: boolean;
}
export function FillInBlank({
  onAnswer,
  disabled
}: FillInBlankProps) {
  const [value, setValue] = useState('');
  const handlePress = (char: string) => {
    if (value.length < 8) {
      setValue(prev => prev + char);
    }
  };
  const handleBackspace = () => {
    setValue(prev => prev.slice(0, -1));
  };
  const handleSubmit = () => {
    if (value.length > 0) {
      onAnswer(value);
      setValue('');
    }
  };
  // Keyboard support
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (disabled) return;
      if (e.key >= '0' && e.key <= '9') {
        handlePress(e.key);
      } else if (e.key === 'Backspace') {
        handleBackspace();
      } else if (e.key === 'Enter') {
        handleSubmit();
      } else if (e.key === '-') {
        handlePress('-');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [value, disabled]);
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '0'];
  return <div className="w-full max-w-md mx-auto space-y-6" data-id="element-47">
      {/* Display Area */}
      <div className="h-20 bg-slate-100 rounded-xl flex items-center justify-center text-4xl font-bold text-slate-900 border-2 border-slate-200" data-id="element-48">
        {value || <span className="text-slate-300 animate-pulse" data-id="element-49">|</span>}
      </div>

      {/* Keypad */}
      <div className="grid grid-cols-3 gap-3" data-id="element-50">
        {keys.map(key => <Button key={key} variant="secondary" size="lg" onClick={() => handlePress(key)} disabled={disabled} className="text-2xl font-semibold bg-white border border-slate-200 shadow-sm hover:bg-slate-50" data-id="element-51">
            {key === '-' ? <Minus className="w-6 h-6" data-id="element-52" /> : key}
          </Button>)}

        {/* Special Keys */}
        <Button variant="secondary" size="lg" onClick={handleBackspace} disabled={disabled || value.length === 0} className="text-slate-500 bg-white border border-slate-200 shadow-sm hover:bg-red-50 hover:text-red-500" data-id="element-53">
          <Delete className="w-6 h-6" data-id="element-54" />
        </Button>
      </div>

      {/* Submit Button */}
      <Button variant="primary" size="lg" fullWidth onClick={handleSubmit} disabled={disabled || value.length === 0} className="mt-4" data-id="element-55">
        <Check className="w-6 h-6 mr-2" data-id="element-56" />
        Check Answer
      </Button>
    </div>;
}